import { useAsyncValue } from 'framework/utils';
import { useShowContext } from 'framework/show';
import { useArtifactService, API_FILE_TYPE, CROP_SIZES } from 'domain/shared/artifact';
import type { ArtifactType } from 'domain/shared/artifact/field';
import { DefaultUserAvatar } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

const CandidateAvatar = () => {
  const { data } = useShowContext();
  const attachmentsIds = (data && data.getValueBySource('photosIds')) || [];
  const isOneArtifact = Boolean(attachmentsIds.length !== 1);
  const { getArtifactsDataByIds } = useArtifactService({ isCandidateService: true });
  const attachments = useAsyncValue(async () =>
    getArtifactsDataByIds(isOneArtifact ? [attachmentsIds] : attachmentsIds),
  );

  const images = attachments && attachments.filter((file: ArtifactType) => file.type === API_FILE_TYPE.image.alias);
  if (!!images && images.length > 0) {
    let thumbnail = images[0].thumbnails && images[0].thumbnails[CROP_SIZES.SIZE_100];
    if (typeof thumbnail === 'undefined') {
      thumbnail = images[0].filePreview;
    }
    const { id, title } = images[0];

    return (
      <Box sx={{ height: '100px', width: '100px' }}>
        <Box
          component="img"
          src={thumbnail}
          alt={title}
          title={title}
          id={id}
          data-testid="artifact-image"
          sx={{ maxWidth: '100%', width: '100%', borderRadius: '3px', height: '100%', objectFit: 'cover' }}
        />
      </Box>
    );
  } else {
    return (
      <Box sx={{ height: '100px', width: '100px' }}>
        <DefaultUserAvatar sx={{ width: '100px', height: '100px' }} />
      </Box>
    );
  }
};

export default CandidateAvatar;
